import { CSSResultGroup, html, LitElement, TemplateResult, css } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { GameStartScreen } from "./game-start-screen";
import { GameCanvas } from "./GameCanvas";

@customElement("game-parent")
export class GameParent extends LitElement {
    @state()
    private screenStatus = "game";

    @property({ type: String })
    public currentUserId = "";

    public static styles: CSSResultGroup = css`
        :host {
            display: flex;
            flex-direction: row;
            justify-content: center;
            height: 100vh;
        }

        game-main-screen {
            max-width: 100%;
        }

        game-start-screen {
            max-width: 100%;
        }

        game-canvas {
            width: 96%;
        }

        @media (min-width: 1080px) {
            game-canvas {
                max-width: 1080px;
            }
        }
    `;
    public render(): TemplateResult<1> {
        return html`
            ${this.screenStatus === "start"
                ? html` <game-start-screen
                      class="main-startscreen"
                      @user-change=${this.onUserSessionChange}
                      @go-ingame=${this.onInGameMode}
                  ></game-start-screen>`
                : html` <game-canvas
                      class="main-mainscreen"
                      @go-mainmenu=${this.handleClickBackToMainMenu}
                  ></game-canvas>`}
        `;
    }

    public onUserSessionChange(event: Event): void {
        const target: GameStartScreen = event.target as GameStartScreen;
        this.currentUserId = target.sessionUserId;
        console.log(this.currentUserId);
    }

    public onInGameMode(event: Event): void {
        const target: GameStartScreen = event.target as GameStartScreen;
        const userInGameStatus: boolean = target.isUserInGame;

        if (userInGameStatus === true) {
            this.screenStatus = "game";
        }

        if (userInGameStatus === false) {
            this.screenStatus = "start";
        }
        console.log("test");
    }

    public handleClickBackToMainMenu(event: Event): void {
        const target: GameCanvas = event.target as GameCanvas;
        const userInGameStatus: boolean = target.isUserInGame;

        if (userInGameStatus === false) {
            this.screenStatus = "start";
        }
        console.log("test");
    }

    public updated(): void {
        console.log("Parent update triggered");
    }
}
